export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13268.d643c0f9.jpg";